interface V3IconPluginProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
    size?: number;
    strokeWidth?: string;
}

export const V3IconPlugin = ({ stroke = "#ABB0BA", strokeWidth = "1.5", size = 24, ...rest }: V3IconPluginProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} fill="none" {...rest}>
        <path
            stroke={stroke}
            strokeLinecap="round"
            strokeWidth={strokeWidth}
            d="M17 21h-4.25v-.75a2.25 2.25 0 0 0-4.5 0V21H4a1 1 0 0 1-1-1v-4.25h.75a2.25 2.25 0 0 0 0-4.5H3V7a1 1 0 0 1 1-1h4.25v-.75a2.25 2.25 0 0 1 4.5 0V6H17a1 1 0 0 1 1 1v4.25h.75a2.25 2.25 0 0 1 0 4.5H18V20a1 1 0 0 1-1 1Z"
        />
    </svg>
);
